import { render } from "./ProgramasComponent.vue?vue&type=template&id=818be166"
import script from "./ProgramasComponent.vue?vue&type=script&lang=js"
export * from "./ProgramasComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__